import { __assign } from "tslib";
import * as React from 'react';
function IconPhoneSizeXs(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 16 16" }, props),
        React.createElement("path", { d: "M5.06217 7H6C6.55228 7 7 6.55228 7 6V4C7 2.89543 6.10457 2 5 2H3C2.44772 2 2 2.44772 2 3C2 8.76831 7.23169 14 13 14C13.5523 14 14 13.5523 14 13V11C14 9.89543 13.1046 9 12 9H10C9.44772 9 9 9.44772 9 10V10.9378C7.45957 10.0974 6.1344 8.81594 5.23608 7.30515L5.06217 7Z" })));
}
export default IconPhoneSizeXs;
